import React from 'react';
import { Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { Section } from '@/components/Landing/LandingKit';
import { fluid, isWeb } from '@/components/Landing/landingTokens';
import { BILLING } from '@/constants/pricingContent';
import { usePricing } from './PricingKit';

function BillingToggle({ isAnnual, onChange }) {
  const { c } = usePricing();
  return (
    <View accessibilityRole={isWeb ? 'radiogroup' : undefined} accessibilityLabel="Billing period" style={{ flexDirection: 'row', alignSelf: 'center', padding: 4, borderRadius: 14, backgroundColor: c.panel }}>
      {[false, true].map(annual => {
        const active = annual === isAnnual;
        const label = annual ? 'Annual' : 'Monthly';
        return <Pressable key={label} onPress={() => onChange(annual)} accessibilityRole="radio" accessibilityState={{ checked: active }} {...(isWeb ? { 'aria-checked': active } : {})} accessibilityLabel={`${label} billing`} style={{ minHeight: 44, paddingHorizontal: 20, paddingVertical: 12, flexDirection: 'row', alignItems: 'center', gap: 8, borderRadius: 10, backgroundColor: active ? c.ink : 'transparent', ...(isWeb ? { cursor: 'pointer', transition: 'background-color 180ms ease' } : {}) }}>
          <Text weight="medium" style={{ color: active ? c.page : c.muted, fontSize: 14, lineHeight: 20 }}>{label}</Text>
          {annual && <Text weight="medium" style={{ color: active ? c.page : c.muted, fontSize: 12, lineHeight: 20 }}>Save {BILLING.savingsPercent}%</Text>}
        </Pressable>;
      })}
    </View>
  );
}

function PricingHero({ topInset = 0, isAnnual, onBillingChange }) {
  const { c, isXS, width } = usePricing();
  const size = fluid(width, 42, 68);
  return (
    <Section label="Pricing" max={1200} top={false} contentStyle={{ paddingTop: (isXS ? topInset : 0) + fluid(width, 112, 144), paddingBottom: 40, alignItems: 'center' }}>
      <Text weight="medium" style={{ color: c.muted, fontSize: 14, marginBottom: 20 }}>Plans for every possibility</Text>
      <Text tag="h1" weight="bold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.08), letterSpacing: -size * 0.04, textAlign: 'center', ...(isWeb ? { whiteSpace: 'pre-line' } : {}) }}>
        {'Super Intelligence that works.\nA plan that fits.'}
      </Text>
      <Text tag="p" style={{ color: c.muted, fontSize: fluid(width, 17, 19), lineHeight: 28, textAlign: 'center', maxWidth: 580, marginTop: 24 }}>
        Start exploring for free. Choose Plus to turn ideas into finished work.
        Go Premium when you need more room to create.
      </Text>
      <View style={{ marginTop: 32 }}><BillingToggle isAnnual={isAnnual} onChange={onBillingChange} /></View>
    </Section>
  );
}

export default React.memo(PricingHero);
